import { Box, FormControl, MenuItem, Select } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import type { BooleanFilterValue } from '../filterTypes';
import type { FilterFieldProps } from '../FilterField.types';
import { FieldLabel } from '../FilterFieldHelpers';
import { menuItemSx, menuPaperSx, selectSx } from '../styles/filterColumnSx';
import '../styles/filterPanel.css';

export function BooleanFilterInput({
  value,
  onChange,
  onClear,
  variant = 'panel',
  label,
}: FilterFieldProps) {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const isColumn = variant === 'column';
  const selected =
    (value as BooleanFilterValue | undefined) == null
      ? ''
      : String((value as BooleanFilterValue).value);

  const select = (
    <FormControl size="small" fullWidth>
      <Select
        displayEmpty
        value={selected}
        onChange={e => {
          const raw = e.target.value as string;
          if (!raw) onClear();
          else onChange({ kind: 'boolean', value: raw === 'true' });
        }}
        {...(isColumn
          ? { sx: selectSx(theme), MenuProps: { PaperProps: { sx: menuPaperSx(theme) } } }
          : { className: 'filter-select' })}
      >
        <MenuItem
          value=""
          {...(isColumn ? { sx: menuItemSx(theme) } : { className: 'filter-menu-item' })}
        >
          <em
            className={isColumn ? undefined : 'filter-placeholder'}
            style={isColumn ? { fontSize: 'var(--filter-font-size)' } : undefined}
          >
            {t('table.filter.all')}
          </em>
        </MenuItem>
        <MenuItem
          value="true"
          {...(isColumn ? { sx: menuItemSx(theme) } : { className: 'filter-menu-item' })}
        >
          {t('table.filter.yes')}
        </MenuItem>
        <MenuItem
          value="false"
          {...(isColumn ? { sx: menuItemSx(theme) } : { className: 'filter-menu-item' })}
        >
          {t('table.filter.no')}
        </MenuItem>
      </Select>
    </FormControl>
  );

  if (isColumn) return select;
  return (
    <Box className="filter-field">
      {label && <FieldLabel>{label}</FieldLabel>}
      {select}
    </Box>
  );
}
